import React, { useCallback, useRef, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { ReactTable, Spinner, TextInput } from 'components'
import ApiHelper from 'helpers/ApiHelper'

const ObjectSearchTable = ({ id, onSubmit, tableHeight = 450 }) => {
  //  --- Variables ---
  const debounceRef = useRef()
  const [inputValue, setInputValue] = useState('')
  const [queryValue, setQueryValue] = useState('')
  const { data, isFetching } = useQuery(
    ['searchObjects', queryValue],
    async () => {
      return await ApiHelper.indexDelegatedObjects(queryValue)
    },
    { refetchOnWindowFocus: false, refetchOnMount: false, initialData: [] }
  )

  //  --- Functionality ---
  const updateFilterValue = useCallback((e) => {
    const value = e.target.value
    setInputValue(value)

    if (debounceRef.current != null) {
      clearTimeout(debounceRef.current)
    }

    debounceRef.current = setTimeout(() => {
      setQueryValue(value)
    }, 500)
  }, [])

  //  --- Response ---
  return (
    <div className="flex h-full flex-col space-y-4">
      <div className="flex flex-row">
        <TextInput
          className="w-full md:w-2/3 xl:w-1/2"
          onChange={updateFilterValue}
          value={inputValue}
          placeholder="Search objects..."
        />
        {isFetching ? <Spinner /> : null}
      </div>
      <ReactTable
        columns={tableHeaders}
        data={data ? data : []}
        height={tableHeight}
        initialSort={{ id: 'name', desc: true }}
        removeFooter={true}
        rowOnClick={onSubmit}
      />
    </div>
  )
}

const tableHeaders = [
  {
    Header: 'Name',
    i18n: 'indexObjects:objectUsersTable.displayName',
    accessor: 'name',
    width: 240,
  },
  {
    Header: 'Tenant',
    i18n: 'indexObjects:objectUsersTable.tenantName',
    accessor: 'tenantName',
    width: 240,
  },
]

export default ObjectSearchTable
